const StaffActionTypes = {
  /*****************  GET STAFF LIST START  *******************/
  GET_STAFF_LIST_START: "get_staff_list_start",
  GET_STAFF_LIST_SUCCESS: "get_staff_list_success",
  GET_STAFF_LIST_FAILURE: "get_staff_list_failure",
  GET_STAFF_LIST_RESPONSE_RESET: "get_staff_list_response_reset",
  GET_STAFF_LIST_RESPONSE_CHANGED: "get_staff_list_response_changed",
  /*****************  GET STAFF LIST END  *******************/

  /*****************  ADD STAFF DETAILS START  *******************/
  ADD_STAFF_DETAILS_START: "add_staff_details_start",
  ADD_STAFF_DETAILS_SUCCESS: "add_staff_details_success",
  ADD_STAFF_DETAILS_FAILURE: "add_staff_details_failure",
  ADD_STAFF_DETAILS_RESPONSE_RESET: "add_staff_details_response_reset",
  ADD_STAFF_DETAILS_RESPONSE_CHANGED: "add_staff_details_response_changed",
  /*****************  ADD STAFF DETAILS END  *******************/

  /*****************  UPDATE STAFF DETAILS START  *******************/
  UPDATE_STAFF_DETAILS_START: "update_staff_details_start",
  UPDATE_STAFF_DETAILS_SUCCESS: "update_staff_details_success",
  UPDATE_STAFF_DETAILS_FAILURE: "update_staff_details_failure",
  UPDATE_STAFF_DETAILS_RESPONSE_RESET: "update_staff_details_response_reset",
  UPDATE_STAFF_DETAILS_RESPONSE_CHANGED:
    "update_staff_details_response_changed",
  /*****************  UPDATE STAFF DETAILS END  *******************/

  /*****************  DELETE STAFF DETAILS START  *******************/
  DELETE_STAFF_DETAILS_START: "delete_staff_details_start",
  DELETE_STAFF_DETAILS_SUCCESS: "delete_staff_details_success",
  DELETE_STAFF_DETAILS_FAILURE: "delete_staff_details_failure",
  DELETE_STAFF_DETAILS_RESPONSE_RESET: "delete_staff_details_response_reset",
  DELETE_STAFF_DETAILS_RESPONSE_CHANGED:
    "delete_staff_details_response_changed",
  /*****************  DELETE STAFF DETAILS END  *******************/

  /*****************  FETCH STAFF DETAILS START  *******************/
  FETCH_STAFF_DETAILS_START: "fetch_staff_details_start",
  FETCH_STAFF_DETAILS_SUCCESS: "fetch_staff_details_success",
  FETCH_STAFF_DETAILS_FAILURE: "fetch_staff_details_failure",
  FETCH_STAFF_DETAILS_RESPONSE_RESET: "fetch_staff_details_response_reset",
  FETCH_STAFF_DETAILS_RESPONSE_CHANGED: "fetch_staff_details_response_changed",
  /*****************  FETCH STAFF DETAILS END  *******************/

  /*****************  BRANCH DROPDOWN LIST START  *******************/
  LIST_BRANCH_DROPDOWN_DETAILS_START: "list_branch_dropdown_details_start",
  LIST_BRANCH_DROPDOWN_DETAILS_SUCCESS: "list_branch_dropdown_details_success",
  LIST_BRANCH_DROPDOWN_DETAILS_FAILURE: "list_branch_dropdown_details_failure",
  LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_RESET:
    "list_dropdown_branch_details_response_reset",
  LIST_BRANCH_DROPDOWN_DETAILS_RESPONSE_CHANGED:
    "list_dropdown_branch_details_response_changed",
  /*****************  BRANCH DROPDOWN LIST DETAILS END  *******************/

  /*****************  GET USERTYPE LIST START  *******************/
  GET_USERTYPE_DROPDOWN_LIST_START: "get_usertype_dropdown_list_start",
  GET_USERTYPE_DROPDOWN_LIST_SUCCESS: "get_usertype_dropdown_list_success",
  GET_USERTYPE_DROPDOWN_LIST_FAILURE: "get_usertype_dropdown_list_failure",
  GET_USERTYPE_DROPDOWN_LIST_RESPONSE_RESET:
    "get_usertype_dropdown_list_response_reset",
  GET_USERTYPE_DROPDOWN_LIST_RESPONSE_CHANGED:
    "get_usertype__dropdown_list_response_changed",
  /*****************  GET USERTYPE LIST END  *******************/

  /*****************  GET DEPARTMENT LIST START  *******************/
  GET_DEPARTMENT_DROPDOWN_LIST_START: "get_department_dropdown_list_start",
  GET_DEPARTMENT_DROPDOWN_LIST_SUCCESS: "get_department_dropdown_list_success",
  GET_DEPARTMENT_DROPDOWN_LIST_FAILURE: "get_department_dropdown_list_failure",
  GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_RESET:
    "get_department_dropdown_list_response_reset",
  GET_DEPARTMENT_DROPDOWN_LIST_RESPONSE_CHANGED:
    "get_department__dropdown_list_response_changed",
  /*****************  GET DEPARTMENT LIST END  *******************/

  /*****************  GET MANAGER LIST START  *******************/
  GET_MANAGER_DROPDOWN_LIST_START: "get_manager_dropdown_list_start",
  GET_MANAGER_DROPDOWN_LIST_SUCCESS: "get_manager_dropdown_list_success",
  GET_MANAGER_DROPDOWN_LIST_FAILURE: "get_manager_dropdown_list_failure",
  GET_MANAGER_DROPDOWN_LIST_RESPONSE_RESET:
    "get_manager_dropdown_list_response_reset",
  GET_MANAGER_DROPDOWN_LIST_RESPONSE_CHANGED:
    "get_manager__dropdown_list_response_changed",
  /*****************  GET MANAGER LIST END  *******************/
};
export default StaffActionTypes;
